function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Dollar Crossed Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "dollar-crossed-jcms3ajcda",
  d: "M9.964.5c5.227 0 9.465 4.237 9.465 9.464s-4.238 9.464-9.465 9.464C4.737 19.428.5 15.191.5 9.964S4.737.5 9.964.5zm0 1C5.289 1.5 1.5 5.29 1.5 9.964c0 4.675 3.79 8.464 8.464 8.464 4.675 0 8.465-3.79 8.465-8.464S14.639 1.5 9.964 1.5zm0 3c.276 0 .5.224.5.5v.881c.545.067 1.03.24 1.45.493.335.2.565.407.693.56.176.212.148.528-.064.704-.212.177-.528.149-.705-.063-.06-.073-.207-.205-.437-.343-.396-.238-.873-.38-1.438-.38-1.114 0-1.757.578-1.757 1.305 0 .794.38 1.022 1.856 1.317 1.911.382 2.66.832 2.66 2.296 0 1.17-.895 2.097-2.265 2.276.004.026.007.054.007.083v.903c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-.903l.007-.08c-.548-.066-1.035-.241-1.458-.495-.335-.2-.564-.407-.692-.56-.176-.213-.148-.528.064-.705.213-.177.528-.148.705.064.06.073.207.206.438.344.395.237.872.38 1.435.38 1.116 0 1.76-.579 1.76-1.307 0-.792-.38-1.02-1.857-1.315-1.91-.383-2.66-.832-2.66-2.298 0-1.167.891-2.092 2.258-2.273V5c0-.276.224-.5.5-.5zM16.087.218c.156-.228.467-.287.695-.13.203.138.272.4.175.616l-.044.078-13 19c-.156.228-.467.287-.695.13-.203-.138-.272-.4-.175-.616l.044-.078 13-19z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2.036 2)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#dollar-crossed-jcms3ajcda"
}));

var SvgDollarCrossed = function SvgDollarCrossed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDollarCrossed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar-crossed.fc50e818.svg";
export { ForwardRef as ReactComponent };